import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/authContext";

/**
 * Mounted once at the top of the admin route tree. Listens for the
 * `onExpired` callback that `AuthProvider` fires when the active
 * JWT crosses its `exp`. Routes the user to `/login`, preserving
 * their current path so they can resume after re-auth.
 */
export function SessionExpiryWatcher() {
  const { onExpired } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const off = onExpired(() => {
      // If the user is already on /login, no need to bounce them.
      if (location.pathname.startsWith("/login")) return;
      const next = `/login?from=${encodeURIComponent(location.pathname + location.search)}`;
      navigate(next, { replace: true });
    });
    return off;
  }, [onExpired, navigate, location]);

  return null;
}
